/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Credentials_Toast_Delete_SuccessInputs */

const es_components_credentials_toast_delete_success = /** @type {(inputs: Components_Credentials_Toast_Delete_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La credencial fue eliminada correctamente`)
};

const en_components_credentials_toast_delete_success = /** @type {(inputs: Components_Credentials_Toast_Delete_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The credential was successfully deleted`)
};

/**
* | output |
* | --- |
* | "The credential was successfully deleted" |
*
* @param {Components_Credentials_Toast_Delete_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_credentials_toast_delete_success = /** @type {((inputs?: Components_Credentials_Toast_Delete_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Credentials_Toast_Delete_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_credentials_toast_delete_success(inputs)
	return en_components_credentials_toast_delete_success(inputs)
});
export { components_credentials_toast_delete_success as "components.credentials.toast.delete.success" }